import React from 'react';
import { routerRedux, Switch } from 'dva/router';
import { ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import dynamic from 'dva/dynamic';
import { generateMenuRouter } from './common/menu';
import Authorized from './utils/Authorized';
import BasicLayout from './layouts/BasicLayout' // menuData, routerData
import UserLayout from './layouts/UserLayout' // routerData
import BlankLayout from './layouts/BlankLayout'
import BindLayout from './layouts/BindLayout'
import styles from './index.less';

const { ConnectedRouter } = routerRedux;
const { AuthorizedRoute } = Authorized;
dynamic.setDefaultLoadingComponent(() => {
  return <Spin size="large" className={styles.globalSpin} />;
});

function RouterConfig({ history, app }) {
  const { menuData, routerData } = generateMenuRouter(app);
  return (
    <ConfigProvider locale={zhCN}>
      <ConnectedRouter history={history}>
        <Switch>
          <AuthorizedRoute
            path="/user"
            render={props => <UserLayout {...{ ...props, routerData }} />}
            authority={['guest', 'admin', 'user']}
            redirectPath="/"
          />
          <AuthorizedRoute
            path="/index"
            render={props => <BlankLayout {...props} />}
            authority={['guest', 'admin', 'user']}
            redirectPath="/"
          />
          <AuthorizedRoute
            path="/accountbind"
            render={props => <BindLayout {...props} />}
            authority={['admin', 'user']}
            redirectPath="/"
          />
          <AuthorizedRoute
            path="/"
            render={props => <BasicLayout {...{ ...props, menuData, routerData }} />}
            authority={['admin', 'user']}
            redirectPath="/user/login"
          />
        </Switch>
      </ConnectedRouter>
    </ConfigProvider>
  );
}

export default RouterConfig;